import { useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Icon from "@mui/material/Icon";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { LANGUES } from "i18n";

// Sélecteur de langue
// - variant "navbar" : bouton globe + menu déroulant (DashboardNavbar)
// - variant "drawer" : rangée de boutons pill blancs, sans icône (sidebar / menu mobile sur fond sombre)
function LanguageSelector({ variant, dense }) {
  const { t, i18n } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);
  const courante = i18n.resolvedLanguage;

  const choisir = (code) => {
    setAnchorEl(null);
    if (code !== courante) i18n.changeLanguage(code);
  };

  if (variant === "drawer") {
    return (
      <MDBox display="flex" alignItems="center" gap={1} sx={{ px: dense ? 0 : 2, py: dense ? 0 : 1 }}>
        {LANGUES.map((l) => (
          <MDBox
            key={l.code}
            onClick={() => choisir(l.code)}
            sx={{
              px: 1.5, py: 0.5, borderRadius: "8px", cursor: "pointer",
              background: l.code === courante ? "rgba(255,255,255,0.2)" : "rgba(255,255,255,0.06)",
              "&:hover": { background: "rgba(255,255,255,0.15)" },
            }}>
            <MDTypography variant="button" sx={{
              color: l.code === courante ? "#fff" : "rgba(255,255,255,0.7)",
              fontWeight: l.code === courante ? 700 : 400, fontSize: 13,
            }}>
              {l.label}
            </MDTypography>
          </MDBox>
        ))}
      </MDBox>
    );
  }

  return (
    <>
      <IconButton
        size="small"
        color="inherit"
        aria-label={t("commun.langue")}
        title={t("commun.langue")}
        onClick={(e) => setAnchorEl(e.currentTarget)}
      >
        <Icon fontSize="medium">language</Icon>
        <MDTypography variant="button" color="inherit" sx={{ ml: 0.5, fontWeight: 700, textTransform: "uppercase" }}>
          {courante}
        </MDTypography>
      </IconButton>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
        {LANGUES.map((l) => (
          <MenuItem key={l.code} selected={l.code === courante} onClick={() => choisir(l.code)}>
            {l.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}

LanguageSelector.defaultProps = {
  variant: "navbar",
  dense: false,
};

LanguageSelector.propTypes = {
  variant: PropTypes.oneOf(["navbar", "drawer"]),
  dense: PropTypes.bool,
};

export default LanguageSelector;
